import { useState } from "react";

import Button from "components/Button";
import HollowButton from "components/HollowButton";

import styles from "./styles.module.scss";

interface Props {
  /** Tytuł początkowy — przy dodawaniu pliku podpowiadamy nazwę bez rozszerzenia. */
  initialTitle: string;
  /** Nazwa pliku pokazywana pod polem (informacyjnie). */
  fileName?: string | null;
  header?: string;
  confirmLabel?: string;
  loading?: boolean;
  onClose: () => void;
  onApply: (title: string) => void;
}

// Nadanie tytułu załącznikowi — odwzorowanie AttachmentTitleModal z Magistratu.
// Header „Nowy załącznik", etykieta „Tytuł załącznika", placeholder „Wprowadź tytuł
// załącznika", przycisk „Załącz". Pole jest wielolinijkowe i wymagane.

const AttachmentTitleModal = ({
  initialTitle,
  fileName,
  header = "Nowy załącznik",
  confirmLabel = "Załącz",
  loading = false,
  onClose,
  onApply,
}: Props) => {
  const [title, setTitle] = useState(initialTitle);

  const canApply = !!title.trim();

  return (
    <div className={styles.overlay} onMouseDown={onClose}>
      <div className={styles.modal} onMouseDown={(e) => e.stopPropagation()}>
        <div className={styles.modalTitle}>{header}</div>

        <div className={styles.modalBody}>
          <div className={styles.field}>
            <label className={styles.fieldLabel}>Tytuł załącznika</label>
            <textarea
              className={styles.textArea}
              value={title}
              autoFocus
              placeholder="Wprowadź tytuł załącznika"
              onChange={(e) => setTitle(e.target.value)}
            />
            {fileName && (
              <span className={styles.fieldLabel}>Plik: {fileName}</span>
            )}
          </div>
        </div>

        <div className={styles.modalFooter}>
          <HollowButton text="Anuluj" onClick={onClose} />
          <Button
            text={confirmLabel}
            loading={loading}
            disabled={!canApply}
            onClick={() => canApply && onApply(title.trim())}
          />
        </div>
      </div>
    </div>
  );
};

export default AttachmentTitleModal;
